import BaseImageImporter from './BaseImageImporter'

export default class SkodaImageImporter extends BaseImageImporter {
  constructor() {
    super('skoda')
  }

  import(configuration) {
    return (configuration.Images || []).map(media => this.mapMedia(media))
  }

  mapMedia(media) {
    return {
      origin: this.id,
      url: media.URL,
      name: media.ViewPoint,
      mime: 'image/png'
    }
  }
}
